import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import { PureComponent } from 'react';
import './card-title.less';
export class CardTitle extends PureComponent {
    render() {
        const rootClass = classnames({
            'card-title': true,
            'card-title--has-link': this.props.backLink,
        }, this.props.className);
        return (_jsxs("div", Object.assign({ className: rootClass }, { children: [!!this.props.backLink && (_jsx("div", Object.assign({ className: "card-title__backlink" }, { children: this.props.backLink }))), _jsx("h2", Object.assign({ className: "card-title__headline" }, { children: this.props.children })), !!this.props.buttons && (_jsx("div", Object.assign({ className: "card-title__buttons" }, { children: this.props.buttons })))] })));
    }
}
